import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PostDetail from './pages/PostDetail';
import About from './pages/About';
import Archive from './pages/Archive';
import Topics from './pages/Topics';
import Contact from './pages/Contact';
import RSSFeed from './pages/RSSFeed';
import Learn from './pages/Learn';
import LessonDetail from './pages/LessonDetail';
import Guides from './pages/Guides';
import GuideDetail from './pages/GuideDetail';
import GuidesPdf from './pages/GuidesPdf';
import Refer from './pages/Refer';
import SubscriberGate from './components/SubscriberGate';

// Admin pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import PostEditor from './pages/admin/PostEditor';
import ChangePassword from './pages/admin/ChangePassword';
import AdminLessons from './pages/admin/AdminLessons';
import LessonEditor from './pages/admin/LessonEditor';
import AdminSocial from './pages/admin/AdminSocial';
import AdminSubscribers from './pages/admin/AdminSubscribers';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Admin Routes (no header/footer) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/post/:id" element={<PostEditor />} />
            <Route path="/admin/lessons" element={<AdminLessons />} />
            <Route path="/admin/lesson/:id" element={<LessonEditor />} />
            <Route path="/admin/social" element={<AdminSocial />} />
            <Route path="/admin/subscribers" element={<AdminSubscribers />} />
            <Route path="/admin/change-password" element={<ChangePassword />} />

            {/* Public Routes (with header/footer) */}
            <Route path="/*" element={
              <>
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/post/:slug" element={<PostDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/archive" element={<Archive />} />
                  <Route path="/topics" element={<Topics />} />
                  <Route path="/guides" element={<Guides />} />
                  <Route path="/guides/:slug" element={<GuideDetail />} />
                  <Route path="/guides-pdf" element={<GuidesPdf />} />
                  <Route path="/refer" element={<Refer />} />
                  <Route path="/learn" element={<SubscriberGate><Learn /></SubscriberGate>} />
                  <Route path="/learn/:slug" element={<SubscriberGate><LessonDetail /></SubscriberGate>} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/rss" element={<RSSFeed />} />
                </Routes>
                <Footer />
              </>
            } />
          </Routes>
          <Toaster position="top-center" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
